import apiClient from '@/services/InvoiceapiClient'
export default {
    //<!-----------------------------customer page api's-------------------------------->
    /**
     * customer index page api
     * @param {*} page 
     * @param {*} count 
     * @param {*} search 
     * @param {*} status 
     */
    getCustomers(page, count, search, status, sort, label, custom, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.get('/customer/' + page + '/' + count + '?sort=' + sort + '&label=' + label + '&search=' + search + '&status=' + status + '&custom=' + custom)
    },
    /**
     * customer index export page api
     * @param {*} page 
     * @param {*} count 
     * @param {*} search 
     * @param {*} status 
     */
    getCustomersExport(page, count, search, status, sort, label, custom, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.get('/customer/export/' + page + '/' + count + '?sort=' + sort + '&label=' + label + '&search=' + search + '&status=' + status + '&custom=' + custom)
    },
    /**
     * 
     * @param {*} form  (cusid , from date , to date)
     * @param {*} token 
     */
    getCustomerStatement(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/customer/statementdetails', data)
    },
    /**
     * customer create api
     * @param {*} form 
     */
    postCustomer(form, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/customer/create', form)
    },
    /**
     * status changes api
     * @param {*} data 
     */
    postCuststatus(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/customer/statuschange', data)
    },
    /**
     * import customer api
     * @param {*} data 
     */
    postImportCustomer(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/customer/import', data)
    },
    /**
     * get update list customer api
     * @param {*} id 
     */
    getCustomer(id,type, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.get('/customer/view/' + id+"?type="+type)
    },
    getAddress(id, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.get('/customer/getAddress/' + id)
    },
    getCustomerLimit(id, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.get('/customer/cuscreditlimit/' + id)
    },
    /**
     * get customer view list
     * @param {*} id 
     */
    getCustomerView(id, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.get('/customer/viewpage/' + id)
    },
    /**
     * customer update api
     * @param {*} form 
     * @param {*} id 
     */
    postCustomerUpdate(form, id, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/customer/update/' + id, form)
    },
    /**
     * show page dropdwon adn extra information needed api
     */
    getCustomerDetails(token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.get('/customer/details')
    },
    getCustomerFilterDetails(token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.get('/customer/filterdetails')
    },
    /**
     * customer tag create api
     * @param {*} tag_name 
     */
    postCustomerTag(tag_name, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/general/CusTagCreate', tag_name)
    },
    /**
     * customer delete api
     * @param {*} ids 
     */
    postCustdelete(ids, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/customer/delete', ids)
    },
    /**
     * filter create api
     * @param {*} data 
     */
    postFiltercreateCustomer(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/customer/filtercreate', data)
    },
    /**
     * filter update api
     * @param {*} data 
     * @param {*} id 
     */
    postFilterudpateCustomer(data, id, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/customer/filterupdate/' + id, data)
    },
    /**
     * filter delete api
     * @param {*} data 
     */
    postFilterdeleteCustomer(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/customer/filterdelete', data)
    },
    /**
     * customer transaction view page api
     * @param {*} page 
     * @param {*} count 
     * @param {*} search 
     * @param {*} status 
     */
    postCustomercreditview(page, count, id, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/customer/customercreditview/' + page + '/' + count, id)
    },
    postCustomeramcview(page, count, id, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/customer/customeramcview/' + page + '/' + count, id)
    },
    postCustomerinvoiceview(page, count, id, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/customer/customerinvoiceview/' + page + '/' + count, id)
    },
    postCustomersalesorderview(page, count, id, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/customer/customersalesorderview/' + page + '/' + count, id)
    },
    postCustomerpackageview(page, count, id, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/customer/customerpackageview/' + page + '/' + count, id)
    },
    postCustomerretainerview(page, count, id, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/customer/customerretainerview/' + page + '/' + count, id)
    },
    postCustomerrecurringview(page, count, id, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/customer/customerrecurringview/' + page + '/' + count, id)
    },
    postCustomerpaymentview(page, count, id, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/customer/customerpaymentview/' + page + '/' + count, id)
    },
    postCustomerquotationview(page, count, id, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/customer/customerquotationview/' + page + '/' + count, id)
    },
    /**
     * 
     * @param {*} id 
     * @param {*} form 
     */
    getCustomerDelete(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/customer/singledelete', data)
    },
    /**
     * 
     * @param {*} id 
     * @param {*} form 
     */
    getDeleteAddress(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/customer/addressdelete', data)
    },
    /**
     * 
     * @param {*} id 
     * @param {*} form 
     */
    getViewTotalCount(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/customer/totalcount', data)
    },
    postUnusedcreditview(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/customer/unusedcreditview', data)
    },
    importcustomervalidation(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/customer/importvalidation', data)
    },
    importCustomer(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/customer/import', data)
    },
    //address create
    postaddress(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/customer/addressedit', data)
    },
    updateCreditLimit(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/customer/creditlimitupdate', data)
    },
    getCurrencyRate(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/customer/currencyexchangerate', data)
    },
    openingBalanceUpdate(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/customer/openingbalanceupdate/' + data.id, data.data)
    },
    checkCustomerExist(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/customer/IsCustomerExist' , data)
    }
}